export enum Severity {
    CRITICAL = 'critical',
    MEDIUM = 'medium',
    LOW = 'low'
}
